
<template>

    <div 
      v-if="!tableData[tableDataIndex]['jt-summary']" >

        <div
          v-for="role of tableData[tableDataIndex]._roles"
          v-bind:key="role.userRoleID"
          class="mt-1">
          <a href="#" class="btn btn-danger btn-sm" v-on:click.prevent="onInternalUserCellRevokeClick(role)">
            <i class="fa fa-ban"></i> 
          </a>
          &nbsp;
          <span v-html="role.title"></span>
        </div>

    </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageInternalUserCellRole",
  props: ['tableData', 'tableDataIndex', 'tableParameter', 'tableParameterIndex'],
  components: {
  },
  data () {
    return {
      permission : null,
    }
  },
  methods: {
    onInternalUserCellRevokeClick(...args) {
      this.$emit('table-cell-custom', ...args);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageInternalUserCellRole.vue